export default {
  en: {
    settings: {
      title: 'Products and services',
      description:
        'Manage the products and services for this organisation. These can be shared with clients and linked to your assessment answers.',
      archivedTitle: 'Archived products',
      add: 'Add product or service',
      questions: '{count} question | {count} questions',
      clients: '{count} client | {count} clients',
      connected: 'Connected',
      columns: {
        product: 'Product or service',
        status: 'Status',
        clients: 'Clients',
        actions: 'Actions',
      },
      placeholder: {
        ownProducts: {
          title: 'No products or services',
          description: `Leave this empty if you don't have multiple products or services`,
        },
        supplierProducts: {
          title: 'No products or services',
          description:
            'Add a product to start linking answers, or check back once products are created',
        },
      },
      archiveProduct: 'Archive product',
    },
    addProductModal: {
      success: 'Product added successfully',
      error: 'Failed to add product. Try again later.',
      title: 'Add a product or service',
      description:
        'You will be able to associate this label with product-specific answers, and allow clients who use this product to access these answers',
      addButton: 'Add product or service',
      productName: 'Product or service name',
      productDescription: 'Description of the product or service',
      productClients: 'What existing clients use this product?',
      duplicateName: 'A product with this name already exists',
      validation: {
        nameRequired: 'Enter a name for the product or service',
        descriptionRequired: 'Enter a description of the product or service',
      },
      cancel: 'Cancel',
      add: 'Add',
    },
    editProductModal: {
      success: 'Product updated successfully',
      error: 'Failed to update product. Try again later.',
      title: 'Edit product or service',
    },
    archiveProductModal: {
      title: 'Are you sure you want to archive this product?',
      listTitle: 'Archiving this product will:',
      listOne: 'Remove any client connections to this product',
      listTwo: 'Archive any answers associated with this product',
      listThree: 'Archive any related discussions you might be having with your client',
      unarchiveWarning: 'You will not be able to unarchive this product in the future',
      cancel: 'Cancel',
      archive: 'Archive product',
      success: 'Product archived successfully',
      error: 'Failed to archive product. Try again later.',
    },
    selectProductDropdown: {
      buttonText: 'Select a product',
      addProductTitle: 'Not seeing the right product?',
      addProductCTA: 'Add another product',
    },
    orgProductsSelect: {
      moreSelected: '+{count} more',
    },
  },
};
